var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfHelpResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5588,
    cy: 26.6195,
    r: 25,
    transform: "rotate(1.80664 26.5588 26.6195)",
    fill: "url(#paint0_linear_209_67367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8796 22.0298L34.1838 44.0912C31.3989 47.7501 26.9351 50.0547 21.9754 49.8983C18.781 49.7975 15.8564 48.691 13.4982 46.8934C12.195 45.9004 11.0646 44.6955 10.1573 43.3334L10.8531 21.272C10.8717 20.6838 11.3658 20.2221 11.9562 20.2408L33.8437 20.9311C34.4342 20.9498 34.8982 21.4417 34.8796 22.0298Z",
    fill: "#D4648A",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4031 18.2603L36.7072 40.3217C33.9223 43.9806 29.4585 46.2852 24.4988 46.1288C21.3044 46.028 18.3799 44.9215 16.0216 43.1238C14.7184 42.1309 13.588 40.926 12.6807 39.5639L13.3766 17.5025C13.3951 16.9143 13.8892 16.4526 14.4797 16.4712L36.3672 17.1616C36.9576 17.1802 37.4216 17.6721 37.4031 18.2603Z",
    fill: "#D4648A",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9148 14.9712L39.2189 37.0327C36.434 40.6915 31.9702 42.9961 27.0106 42.8397C23.8162 42.7389 20.8916 41.6324 18.5333 39.8348C17.2301 38.8418 16.0998 37.6369 15.1924 36.2748L15.8883 14.2134C15.9068 13.6252 16.4009 13.1635 16.9914 13.1822L38.8789 13.8726C39.4693 13.8912 39.9333 14.3831 39.9148 14.9712Z",
    fill: "url(#paint1_linear_209_67367)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 39.3046L18.9373 39.3045C17.749 38.3991 16.7111 37.309 15.8656 36.08L16.5546 14.2344C16.5615 14.017 16.7451 13.8414 16.9704 13.8485L38.8579 14.5389C39.0831 14.546 39.2553 14.7328 39.2485 14.9502L38.5594 36.7958C35.8923 40.1929 31.6915 42.3204 27.0316 42.1734C23.9803 42.0771 21.1888 41.0207 18.9375 39.3046Z",
    stroke: "#F16480",
    strokeOpacity: 0.6,
    strokeWidth: 1.33333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 19.457L37.8268 20.0936L37.6449 25.86L17.4626 25.2234L17.6445 19.457Z",
    fill: "url(#paint2_linear_209_67367)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 30.5234L28.8295 30.872L28.6477 36.6384L17.5955 36.2898L17.7773 30.5234Z",
    fill: "url(#paint3_linear_209_67367)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8863 14.2749L15.7855 17.4732L39.812 18.2311L39.9129 15.0327C39.9325 14.4105 39.4693 13.8912 38.8787 13.8725L16.9916 13.1822C16.4009 13.1635 15.906 13.6526 15.8863 14.2749Z",
    fill: "#F16480"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7272 13.3L17.0593 13.1843C16.4312 13.1645 15.906 13.6526 15.8863 14.2749L15.7855 17.4732L19.4534 17.5889L19.5543 14.3906C19.5739 13.7683 20.0991 13.2802 20.7272 13.3Z",
    fill: "#D4648A",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6828 26.3422L17.8759 25.7175C17.6394 25.71 17.4538 25.5191 17.461 25.2913L17.6471 19.3892C17.6543 19.1614 17.8516 18.9826 18.0881 18.9901L37.895 19.6148C38.1315 19.6223 38.3171 19.8132 38.3099 20.041L38.1238 25.9431C38.1166 26.1711 37.9193 26.3497 37.6828 26.3422ZM18.3299 24.9057L37.2809 25.5034L37.4411 20.4266L18.49 19.8289L18.3299 24.9057Z",
    fill: "#F16480"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1918 37.5895L17.5112 37.2526C17.2758 37.2452 17.091 37.0548 17.0981 36.8275L17.2995 30.4429C17.3067 30.2156 17.5031 30.0373 17.7386 30.0447L28.4191 30.3816C28.6546 30.389 28.8394 30.5794 28.8322 30.8067L28.6309 37.1911C28.6237 37.4186 28.427 37.597 28.1918 37.5895ZM17.9633 36.4428L27.7917 36.7528L27.9671 31.1915L18.1387 30.8815L17.9633 36.4428Z",
    fill: "#F16480"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3987 31.2981L30.5859 31.0832C30.3486 31.0758 30.1626 30.8774 30.1701 30.6403C30.1775 30.4033 30.3757 30.217 30.613 30.2245L37.4258 30.4394C37.6631 30.4469 37.8491 30.6452 37.8416 30.8823C37.8342 31.1194 37.636 31.3056 37.3987 31.2981Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4716 28.9289L17.5976 28.302C17.3603 28.2945 17.1743 28.0961 17.1818 27.8591C17.1892 27.622 17.3874 27.4357 17.6247 27.4432L37.4987 28.0701C37.736 28.0776 37.922 28.276 37.9146 28.513C37.9071 28.7501 37.7089 28.9363 37.4716 28.9289Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3284 33.5208L30.5156 33.3059C30.2783 33.2984 30.0923 33.1 30.0997 32.863C30.1072 32.6259 30.3054 32.4397 30.5427 32.4471L37.3555 32.662C37.5928 32.6695 37.7788 32.8679 37.7713 33.105C37.7639 33.342 37.5657 33.5283 37.3284 33.5208Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2581 35.7395L30.4453 35.5246C30.208 35.5172 30.0219 35.3188 30.0294 35.0817C30.0369 34.8444 30.2351 34.6584 30.4723 34.6659L37.2852 34.8808C37.5225 34.8883 37.7085 35.0864 37.701 35.3237C37.6935 35.5608 37.4954 35.747 37.2581 35.7395Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7814 37.8508L30.3749 37.7434C30.1377 37.7359 29.9516 37.5375 29.9591 37.3005C29.9666 37.0632 30.1648 36.8772 30.402 36.8846L33.8085 36.9921C34.0457 36.9996 34.2318 37.1977 34.2243 37.435C34.2168 37.6721 34.0186 37.8583 33.7814 37.8508Z",
    fill: "#D9D8D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_67367",
    x1: 26.5588,
    y1: 1.61949,
    x2: 26.5588,
    y2: 47.0522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_67367",
    x1: 27.9351,
    y1: 13.5274,
    x2: 27.1924,
    y2: 37.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_67367",
    x1: 27.7357,
    y1: 19.7753,
    x2: 27.5538,
    y2: 25.5417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67F97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_67367",
    x1: 23.3034,
    y1: 30.6977,
    x2: 23.1216,
    y2: 36.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67F97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfHelpResources);
export default __webpack_public_path__ + "static/media/self-help-resources.24e917084f8ae6f09b6d36c5a99f7114.svg";
export { ForwardRef as ReactComponent };